import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
// import ArrowIcon from "src/assets/Arrow.png";
import LoadingSpinner from "src/components/LoadingSpinner";
import { Link } from "react-router-dom";
// import { ZENDDESK_FAQ } from "src/constants";
export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            loader: false,
            getAllPlanData: [],
            getAllAddonData: [],
            subscriptionPlan: {},
            activeContainer: [],
            upgradeDetails: {}
          });
          public componentDidMount() {
            this.getUpgradeDetails()
            this.getAllPlanHandler()
            // Scroll to bottom after page loads
            this.scrollToBottom()
          }

          public componentDidUpdate(prevProps: IProps, prevState: IDirectorSettingsState) {
            // Scroll to bottom when loader finishes and content is loaded
            if (prevState.loader === true && this.state.loader === false && this.state.getAllPlanData.length > 0) {
              setTimeout(() => {
                this.scrollToBottom();
              }, 300);
            }
          }

          public scrollToBottom = () => {
            // Multiple attempts to ensure scroll works
            const scroll = () => {
              const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
              const windowHeight = window.innerHeight;
              const offsetFromBottom = 50; // 50px from bottom
              
              // Calculate scroll position: total height - window height - offset from bottom
              const scrollPosition = scrollHeight - windowHeight - offsetFromBottom;
              
              window.scrollTo({
                top: scrollPosition,
                left: 0,
                behavior: 'smooth'
              });
            };

            // Try scrolling immediately
            requestAnimationFrame(() => {
              scroll();
              // Retry after a delay to ensure content is rendered
              setTimeout(() => {
                scroll();
              }, 500);
            });
          }
          public getUpgradeDetails = () => {
            const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
            const parsedObject = JSON?.parse(storedObject);
            if (Object.keys(parsedObject).length > 0) {
              this.setState({ upgradeDetails: parsedObject })
            }
          }
          public async getAllPlanHandler() {
            this.setState({ loader: true })
            const res: any = await this.buildGet(this, "payment/getPlan")()
            console.log("USERRESPO=====>", res)
            if (res.status && res?.data?.length > 0) {
              const data = res.data.sort((a: any, b: any) => a.id - b.id);
              this.setState({ getAllPlanData: data }, () => {
                this.setState({ loader: false }, () => {
                  // Scroll to bottom after content is loaded
                  setTimeout(() => {
                    this.scrollToBottom();
                  }, 500);
                });
              });
            } else {
              this.setState({ loader: false }, () => {
                setTimeout(() => {
                  this.scrollToBottom();
                }, 500);
              });
            }
            // this.setState({ user: res })
          }

          public buyPlanHandler(item: any) {
            localStorage.setItem("upgradeDetails", JSON.stringify({ plan: item }));
          }
          public getFrequentyType(price: any, key: any) {
            switch (key) {
              case "free":
                return "Free"
              case "yearly":
                return `$${price}/yr`
              default:
                return ""
            }
          }
          public planRenderUI(item: any, index: any) {
            switch (item.id) {
              case 2:
                return this.starterPlanRender(item, index)
              case 3:
                return this.proPlanRender(item, index)
              case 4:
                return this.premierPlanRender(item, index)
              case 5:
                return this.elitePlanRender(item, index)
              default:
                return null
            }
          }
          public starterPlanRender(item: any, index: any) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-3" key={index}>
                <div className="start-main-div">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-blue fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="starter-inner-part">
                      <div className="starter-inner-content">
                        <h2>{item.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="start-list">
                          <ul>
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }
                          </ul>
                          <div className="buy-now-div">
                            <Link to={`/${this.props.school?.slug}/addon-plans`}
                              onClick={() => {
                                this.buyPlanHandler(item)
                              }}>
                              <button className="buy-now-btn"><span>Buy Now</span></button>
                            </Link>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>)

          }
          public proPlanRender(item: any, index: any) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-3 pl-0">
                <div className="pro">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-blue fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="starter-inner-part">
                      <div className="starter-inner-content">
                        <h2>{item?.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="start-list">
                          <ul className="pro-ul">
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }

                          </ul>
                          <div className="buy-now-div">
                            <Link to={`/${this.props.school?.slug}/addon-plans`}
                              onClick={() => {
                                this.buyPlanHandler(item)
                              }}>
                              <button className="buy-now-btn"><span>Buy Now</span></button>
                            </Link>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          public premierPlanRender(item: any, index: any) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (<div className="col-lg-3 pl-0">
              <div className="premier">
                <div className="starter">
                  <div className="starter-content">
                    <div className="fa-icon-dev">
                      <i className="fa-grey fa-solid fa-circle" />
                      <i className="fa-grey fa-solid fa-circle" />
                      <i className="fa-blue fa-solid fa-circle" />
                      <i className="fa-grey fa-solid fa-circle" />
                    </div>
                    <div className="price-dev">
                      <div className="price-inner-content">
                        <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                      </div>

                    </div>
                  </div>
                  <div className="starter-inner-part">
                    <div className="starter-inner-content">
                      <div className="most-popular">
                        <div>
                          <h2>{item?.title}</h2>
                        </div>
                        <div className="most-inner-popular">
                          <h4>Most Popular</h4>
                        </div>
                      </div>
                      <p>{item?.description}</p>
                      <h4>What’s Included? </h4>
                      <div className="start-list">
                        <ul className="premier-ul">
                          {
                            tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                              return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                            }) : null
                          }
                        </ul>
                        <div className="buy-now-div">
                          <Link to={`/${this.props.school?.slug}/addon-plans`}
                            onClick={() => {
                              this.buyPlanHandler(item)
                            }}>
                            <button className="buy-now-btn"><span>Buy Now</span></button>
                          </Link>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>)
          }

          public elitePlanRender(item: any, index: any) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-3 pl-0">
                <div className="elite">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-blue fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="elite-inner-part">
                      <div className="elite-inner-content">
                        <h2>{item?.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="elite-list">
                          <ul className="elite-ul">
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }
                          </ul>
                          <div className="buy-now-div">
                            <Link to={`/${this.props.school?.slug}/addon-plans`}
                              onClick={() => {
                                this.buyPlanHandler(item)
                              }}>
                              <button className="buy-now-btn"><span>Buy Now</span></button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          public render() {
            const {
              appContext: { user, baseUri },
              classes,
            } = this.props;
            console.log(user, classes, baseUri)

            return (
                <div>
              {this.state.loader &&<div className="loader-bg-color">
                <LoadingSpinner /></div>}
              <Page
                header={'Subscription Plans'}
                subtitle={''}
              >
                <div>
                  <div className="containerr">
                    <h4 style={{ textAlign: "center" }} className="wanttoupgrade">Want to Upgrade?</h4>
                  {/* <div className="culture-content">
                    
                        <div className="culture-inner-content" style={{paddingTop:"20px"}}>
                          <p>Your current plan is <b>{this.props.userSubscription?.plans?.title }</b>. If you <b>want to upgrade</b> your plan to a new level please select other plan. </p>
                        </div>

                      </div> */}

                    <div className="pricing-main-div">
                      <div className="row p-4" style={{display:"flex",alignItems:'flex-end'}}>
                        {
                          this.state.getAllPlanData?.filter((item: any) => item?.id !== 1).map((item: any, index: number) => {
                            return this.planRenderUI(item, index)
                          })
                        }
                        {/* <div className="col-lg-3">
                                        <div className="pro">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Pro</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="pro-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>


                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/propage"><button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="premier">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Premier</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="premier-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>

                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/premierpage"> <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="elite">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="elite-inner-part">
                                                    <div className="elite-inner-content">
                                                        <h2>Elite</h2>
                                                        <p>For schools that want unlimited access to build coaches, culture, and athletic director leadership.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="elite-list">
                                                            <ul className="elite-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                      </div>

                      {/* <div className="culture-content">
                        <div className="culture-inner-content">
                          <h2>Culture and Coach Training</h2>
                          <p>If you want more than just an opinion survey system, culture and coach training for your staff and your community is what's next.</p>
                          <button className="culture-btn" onClick={()=>{
                            window.open(ZENDDESK_FAQ)
                          }}><span>CONTACT US</span></button>
                        </div>

                      </div> */}
                    </div>
                  </div>
                </div>
                
              </Page>
              </div>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/upgradeSubscription/subscriptionPlan.tsx